var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVeryDifficult(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9993 3.33439C8.10831 3.33439 3.33268 8.11002 3.33268 14.0011C3.33268 19.8921 8.10831 24.6677 13.9993 24.6677C19.8904 24.6677 24.666 19.8921 24.666 14.0011C24.666 8.11002 19.8904 3.33439 13.9993 3.33439ZM0.666016 14.0011C0.666016 6.63726 6.63555 0.667725 13.9993 0.667725C21.3631 0.667725 27.3327 6.63726 27.3327 14.0011C27.3327 21.3649 21.3631 27.3344 13.9993 27.3344C6.63555 27.3344 0.666016 21.3649 0.666016 14.0011Z",
    fill: "#AAAAAA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66602 11.3344C8.66602 10.598 9.26297 10.0011 9.99935 10.0011H10.0127C10.7491 10.0011 11.346 10.598 11.346 11.3344C11.346 12.0708 10.7491 12.6677 10.0127 12.6677H9.99935C9.26297 12.6677 8.66602 12.0708 8.66602 11.3344Z",
    fill: "#AAAAAA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.666 11.3344C16.666 10.598 17.263 10.0011 17.9993 10.0011H18.0127C18.7491 10.0011 19.346 10.598 19.346 11.3344C19.346 12.0708 18.7491 12.6677 18.0127 12.6677H17.9993C17.263 12.6677 16.666 12.0708 16.666 11.3344Z",
    fill: "#AAAAAA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9993 18.267C13.5559 18.267 13.1169 18.3555 12.708 18.5273C12.2992 18.6991 11.9288 18.9508 11.6184 19.2675C11.103 19.7935 10.2589 19.8021 9.73288 19.2868C9.20689 18.7714 9.19828 17.9272 9.71364 17.4013C10.2723 16.8311 10.9391 16.3781 11.675 16.0689C12.4109 15.7597 13.2011 15.6004 13.9993 15.6004C14.7976 15.6004 15.5878 15.7597 16.3237 16.0689C17.0596 16.3781 17.7264 16.8311 18.2851 17.4013C18.8004 17.9272 18.7918 18.7714 18.2658 19.2868C17.7398 19.8021 16.8957 19.7935 16.3803 19.2675C16.0699 18.9508 15.6995 18.6991 15.2907 18.5273C14.8818 18.3555 14.4428 18.267 13.9993 18.267Z",
    fill: "#AAAAAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVeryDifficult);
export default __webpack_public_path__ + "static/media/very-difficult.7be62ba13bdd4046da2d93eba8e1e509.svg";
export { ForwardRef as ReactComponent };